"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessages = void 0;
const en_json_1 = __importDefault(require("../locale/en.json"));
exports.defaultMessages = en_json_1.default.en;
//# sourceMappingURL=default-messages.js.map